import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "custom-notification__icon" }, null, -1)
const _hoisted_3 = {
  key: 1,
  class: "custom-notification__title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]

import { onMounted, ref, watch } from 'vue'
import type { Ref } from 'vue'
import Nav from '@/components/Nav/index.vue'
import 'normalize.css'
import '@fontsource/source-sans-pro'
import '@fontsource/source-code-pro'
import 'material-icons/iconfont/filled.css'
import LoadingSpinner from './components/LoadingSpinner/index.vue'
import { usersApi } from '@/api/usersApi'
import { User } from '@/api/authApi/types'
import authStore from '@/store/auth'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const currentUser: Ref<User | null> = ref(null)
const loading = ref<boolean>(true)
const route = useRoute()
const router = useRouter()
const { setCurrentUserUuid } = authStore

watch(() => route.fullPath, refreshUserData)

async function logout() {
  await authStore.logoutUser()
  await router.push('/login')
}

async function refreshUserData() {
  const user = await usersApi.get()
  if (user) {
    currentUser.value = user
    setCurrentUserUuid(user.uuid)
  } else {
    currentUser.value = null
    if (!router.currentRoute.value.meta.skipAuth) await logout()
  }
  loading.value = false
}

onMounted(refreshUserData)

return (_ctx: any,_cache: any) => {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_notifications, {
      position: "top center",
      width: "320",
      closeOnClick: ""
    }, {
      body: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["custom-notification", `custom-notification--${item.type}`])
        }, [
          (item.data.click)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: item.data.click,
                class: "custom-notification__close"
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          _hoisted_2,
          (item.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(item.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "custom-notification__text",
            innerHTML: item.text
          }, null, 8, _hoisted_4),
          (item.data.click)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "custom-notification__cta",
                onClick: item.data.click
              }, " OK ", 8, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }),
    (!_unref(route).meta.hideNavbar)
      ? (_openBlock(), _createBlock(Nav, {
          key: 0,
          currentUser: currentUser.value
        }, null, 8, ["currentUser"]))
      : _createCommentVNode("", true),
    _createElementVNode("main", null, [
      (loading.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
        : (_openBlock(), _createBlock(_component_router_view, {
            key: _ctx.$route.query.refresh
          }))
    ])
  ], 64))
}
}

})